export default __webpack_public_path__ + "3773227c270231b089afb5ea7f9426b9.gif";